/* Careatic — breed collection: wear filters, sort, in-stock toggle, quick-size
   drawer (real variants), and an in-view sticky buy bar. Buy Now / Add to Cart
   submit the chosen variant through the native cart so the Shiprocket Smart Cart
   drawer (Fastrr express checkout) opens, same as the rest of the store. */
(function () {
  'use strict';
  function money(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }

  function init() {
    var grid = document.querySelector('[data-ca-coll-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ca-card]'));
    var filters = document.querySelector('[data-ca-coll-filters]');
    var sortSel = document.querySelector('[data-ca-sort]');
    var instock = document.querySelector('[data-ca-instock]');
    var countEl = document.querySelector('[data-ca-count]');
    var wear = 'all';
    var WEAR = { all: null, rain: ['jumpsuit', 'sleeveless'], tshirt: ['tshirt'], shirt: ['shirt'] };

    function visibleForWear(c) {
      if (wear === 'all') return true;
      return (WEAR[wear] || []).indexOf(c.getAttribute('data-wear')) >= 0;
    }
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = visibleForWear(c);
        if (ok && instock && instock.checked && c.classList.contains('ca-ccard--oos')) ok = false;
        c.classList.toggle('ca-ccard--hidden', !ok);
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown + ' products';
    }
    function sortCards() {
      var mode = sortSel ? sortSel.value : 'best';
      cards.slice().sort(function (a, b) {
        var oa = a.classList.contains('ca-ccard--oos') ? 1 : 0, ob = b.classList.contains('ca-ccard--oos') ? 1 : 0;
        if (oa !== ob) return oa - ob;
        var pa = parseInt(a.getAttribute('data-price') || '0', 10), pb = parseInt(b.getAttribute('data-price') || '0', 10);
        if (mode === 'price-asc') return pa - pb;
        if (mode === 'price-desc') return pb - pa;
        return 0;
      }).forEach(function (c) { grid.appendChild(c); });
    }
    if (filters) {
      filters.querySelectorAll('.ca-pill').forEach(function (p) {
        p.addEventListener('click', function () {
          wear = p.getAttribute('data-wear');
          filters.querySelectorAll('.ca-pill').forEach(function (x) { x.setAttribute('data-active', String(x === p)); });
          if (window.caTrack) window.caTrack('select_item', { item_list_id: 'wear_filter', item_id: wear });
          apply();
        });
      });
    }
    if (sortSel) sortSel.addEventListener('change', function () { sortCards(); apply(); });
    if (instock) instock.addEventListener('change', apply);
    apply();

    /* ---- quick-size drawer ---- */
    var root = document.querySelector('[data-ca-drawer-root]');
    if (root) {
      var titleEl = root.querySelector('[data-ca-drawer-title]');
      var recEl = root.querySelector('[data-ca-drawer-rec]');
      var sizesEl = root.querySelector('[data-ca-drawer-sizes]');
      var priceEl = root.querySelector('[data-ca-drawer-price]');
      var metaEl = root.querySelector('[data-ca-drawer-meta]');
      var trustEl = root.querySelector('[data-ca-drawer-trust]');
      var form = root.querySelector('[data-ca-drawer-form]');
      var vidInput = root.querySelector('[data-ca-drawer-vid]');
      var submitBtn = root.querySelector('[data-ca-drawer-submit]');
      var st = { variants: [], sel: null, mode: 'cart', name: '', wearlabel: '', rec: '' };

      function renderPrice() {
        var v = st.sel; if (!v) { priceEl.innerHTML = ''; return; }
        var pct = (v.mrp && v.mrp > v.price) ? Math.round((v.mrp - v.price) / v.mrp * 100) : 0;
        var h = '<div class="ca-priceblock ca-priceblock--lg"><div class="ca-priceblock__row"><span class="ca-priceblock__sale">' + money(v.price) + '</span>';
        if (v.mrp && v.mrp > v.price) h += '<span class="ca-priceblock__mrp">' + money(v.mrp) + '</span>';
        if (pct > 0) h += '<span class="ca-priceblock__flag">' + pct + '% OFF</span>';
        h += '</div>';
        if (v.mrp && v.mrp > v.price) h += '<div class="ca-priceblock__save">You save ' + money(v.mrp - v.price) + '</div>';
        priceEl.innerHTML = h + '</div>';
        metaEl.textContent = 'Size ' + v.size + ' · ' + st.wearlabel + ' · incl. taxes';
      }
      function select(v) {
        st.sel = v;
        sizesEl.querySelectorAll('[data-ca-sizechip]').forEach(function (ch) { ch.setAttribute('data-active', String(ch.getAttribute('data-vid') === String(v.id))); });
        vidInput.value = v.id;
        renderPrice();
        var lbl = submitBtn.querySelector('span');
        if (lbl) lbl.textContent = (st.mode === 'buy' ? 'Buy Now · ' : 'Add to Cart · ') + money(v.price);
      }
      function buildChips() {
        sizesEl.innerHTML = '';
        st.variants.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'ca-sizechip'; b.setAttribute('data-ca-sizechip', ''); b.setAttribute('data-vid', v.id);
          b.setAttribute('data-soldout', String(!v.available));
          if (!v.available) b.disabled = true;
          b.innerHTML = v.size + ((st.rec && String(v.size) === String(st.rec)) ? '<span class="ca-sizechip__rec">Your fit</span>' : '');
          if (v.available) b.addEventListener('click', function () { select(v); });
          sizesEl.appendChild(b);
        });
      }
      function open(card, mode) {
        st.mode = mode;
        st.name = card.getAttribute('data-ca-name');
        st.wearlabel = card.getAttribute('data-ca-wearlabel');
        st.rec = card.getAttribute('data-ca-rec');
        try { st.variants = JSON.parse(card.getAttribute('data-ca-variants') || '[]'); } catch (e) { st.variants = []; }
        titleEl.textContent = st.name;
        recEl.textContent = st.rec ? '✓ Size ' + st.rec + ' recommended' : '';
        trustEl.hidden = (mode !== 'buy');
        buildChips();
        var pre = null;
        st.variants.forEach(function (v) { if (!pre && v.available && st.rec && String(v.size) === String(st.rec)) pre = v; });
        if (!pre) st.variants.forEach(function (v) { if (!pre && v.available) pre = v; });
        if (pre) select(pre);
        root.setAttribute('data-open', 'true');
        document.body.style.overflow = 'hidden';
      }
      function close() { root.setAttribute('data-open', 'false'); document.body.style.overflow = ''; }
      root.querySelectorAll('[data-ca-drawer-close]').forEach(function (x) { x.addEventListener('click', close); });

      grid.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-ca-open]');
        if (!opener) return;
        var card = opener.closest('[data-ca-card]');
        if (card) open(card, opener.getAttribute('data-ca-open'));
      });
      form.addEventListener('submit', function () {
        var v = st.sel; if (!v) return;
        if (window.caTrack) window.caTrack(st.mode === 'buy' ? 'begin_checkout' : 'add_to_cart', { item_name: st.name, size: v.size, value: Math.round(v.price / 100) });
      }, true);

      /* sticky bar */
      var sticky = document.querySelector('[data-ca-coll-sticky]');
      if (sticky) {
        var sName = sticky.querySelector('[data-ca-sticky-name]');
        var sMeta = sticky.querySelector('[data-ca-sticky-meta]');
        var sBuy = sticky.querySelector('[data-ca-sticky-buy]');
        var current = null;
        var onScroll = function () { sticky.setAttribute('data-show', String(window.scrollY > 500)); };
        window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting && !en.target.classList.contains('ca-ccard--oos') && !en.target.classList.contains('ca-ccard--hidden')) {
                current = en.target;
                sName.textContent = current.getAttribute('data-ca-name');
                sMeta.textContent = money(parseInt(current.getAttribute('data-price') || '0', 10));
              }
            });
          }, { threshold: [0.5] });
          cards.forEach(function (c) { io.observe(c); });
        }
        if (sBuy) sBuy.addEventListener('click', function () {
          if (current) { var btn = current.querySelector('[data-ca-open="buy"]'); if (btn) btn.click(); }
        });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
